export default "__VITE_ASSET__DOq5TGFI__"